import { createContext, useContext } from "react";

const AppointmentContext = createContext({ openAppointment: () => {} });

export function AppointmentProvider({ children, openAppointment }) {
  return (
    <AppointmentContext.Provider value={{ openAppointment }}>
      {children}
    </AppointmentContext.Provider>
  );
}

export function useAppointment() {
  return useContext(AppointmentContext);
}
